"use client"

import { ArrowBigLeft } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowBigLeftIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowBigLeftIcon = component(Icon)({ as: ArrowBigLeft })
